import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import CameraIcon from "../Svgs/CameraIcon";
import { uploadProfileImageForPartner } from "../../apis";
import { useNavigate } from "react-router-dom";
import RowLoader from "../UI/RowLoader";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const validationSchema = Yup.object({
  image: Yup.mixed()
    .required("Image is required")
    .test("fileSize", "File size must be less than 5MB", (file) => {
      return file && file.size <= MAX_FILE_SIZE;
    })
    .test("fileFormat", "Unsupported file format", (file) => {
      return (
        file && ["image/jpeg", "image/jpg", "image/png"].includes(file.type)
      );
    }),
});

const UpdatePartnerProfileImage = ({ profilePic }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(null);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      image: null,
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("profile_pic", values.image);
      setLoading(true);
      uploadProfileImageForPartner(formData)
        .then(() => {
          Swal.fire(
            "Success",
            "Profile image updated successfully",
            "success"
          ).then(() => {
            resetForm();
            navigate(0);
          });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            error?.message || "Failed to upload image",
            "error"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const handleChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue("image", file);

    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const clearImage = () => {
    formik.setFieldValue("image", null);
    setPreviewUrl(null);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="tw-relative ">
        <div className="tw-inline-block tw-w-28 tw-h-28 tw-relative">
          <img
            src={previewUrl || profilePic || "/imgs/partner.png"}
            alt="Profile"
            className="tw-w-full tw-h-full tw-object-cover tw-rounded-full"
          />

          <label
            htmlFor="uploadProfile"
            className="tw-bg-white tw-p-1 tw-rounded-full tw-absolute tw-right-0 -tw-bottom-1 tw-cursor-pointer"
          >
            <CameraIcon />
          </label>

          {previewUrl && (
            <span
              onClick={clearImage}
              className="tw-bg-red-500 tw-text-white tw-w-5 tw-h-5 tw-text-xs tw-flex tw-items-center tw-justify-center tw-rounded-full tw-absolute tw-right-0 -tw-top-1 tw-cursor-pointer"
            >
              x
            </span>
          )}

          <input
            id="uploadProfile"
            name="image"
            type="file"
            className="d-none"
            onChange={handleChange}
            accept=".jpg, .jpeg, .png"
          />
        </div>

        {formik.errors.image && formik.touched.image && (
          <div className="tw-text-red-500 tw-text-sm tw-mt-1">
            {formik.errors.image}
          </div>
        )}
      </form>
      <button
        disabled={!formik.values.image || loading}
        onClick={formik.handleSubmit}
        type="submit"
        className="btn btn-primary !tw-text-sm !tw-m-0 !tw-bg-primary hover:!tw-bg-primaryLight disabled:!tw-bg-slate-400 !tw-w-[130px] tw-text-white mt-1 tw-px-2 !tw-py-1 tw-rounded-full tw-shadow-lg"
      >
        {loading ? <RowLoader paddingStyle="tw-py-0" /> : "Upload Image"}
      </button>
    </>
  );
};

export default UpdatePartnerProfileImage;
